import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../utils/config/config";
import Layout from "../../layouts/Layout";
import HeadingWithBtns from "../Common/HeadingWithBtns";
import { ConfirmationSnackbar, ErrorSnackbar } from "../Common/CustomSnackbar";
import CreatorInfo from "../Creators/CreatorInfo";
import AnalyticsBoxes from "../Creators/AnalyticsBoxes";
import { Grid2, Stack, useMediaQuery } from "@mui/material";
import { SecondaryBtn } from "../Common/CustomBtn";
import { CustomInputLabel } from "../Creators/CustomInputLabel";
import { CustomDropDown } from "../Common/CustomDropdown";
import { useSelector } from "react-redux";
import CreatorSubscriberPosts from "./CreatorSubscriberPosts";
import SummaryTable from "./SummaryTable";

const CreatorTransactions = () => {
  const { id } = useParams();
  const { userData: currentUser } = useSelector((state) => state.user);
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });
  const [success, setSuccess] = useState(false);
  const [userData, setUserData] = useState(null);
  const [analytics, setAnalytics] = useState(null);

  const fetchCreator = async () => {
    try {
      const response = await axiosInstance.get(
        `/user/getCreatorTransactionsData/${id}`
      );

      setUserData(response.data.resp);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAnalytics = async () => {
    try {
      const resp = await axiosInstance.get(`user/analytics/${userData.id}`);

      setAnalytics(resp.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchCreator();
    }
  }, [id]);
  useEffect(() => {
    if (userData) {
      fetchAnalytics();
    }
  }, [userData]);
  return (
    <Layout>
      <HeadingWithBtns creator={userData} analytics />

      <ErrorSnackbar
        error={errorState.error}
        errorMsg={errorState.message}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={"Profile URL Copied to clipboard!."}
      />

      {userData && <CreatorInfo userData={userData} isSelf />}

      <AnalyticsBoxes
        isSubscribed={false}
        isAdmin={true}
        teir={null}
        visitingId={userData?.id}
        data={analytics}
      />
      <SummaryTable data={userData} />
      {userData && (
        <CreatorSubscriberPosts
          creatorSubscribers={userData.creatorSubscribers}
          posts={userData.posts}
          success={success}
          setSuccess={setSuccess}
          setErrorState={setErrorState}
          fetchTabData={fetchCreator}
          isSubscribed={userData.subscribed}
          currentPlan={userData.subscriptionPlan}
        />
      )}
    </Layout>
  );
};

export default CreatorTransactions;
